module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane-snapshot-wrapper"
  }, [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "w5-form-additional-info",
    staticStyle: {
      "margin-right": "0",
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "w5-form-row js-end",
    class: {
      'with-table': _vm.cacheData && _vm.cacheData.length
    }
  }, [_c('div', {
    staticClass: "btn btn-submit font-weight-300",
    attrs: {
      "disabled": !_vm.Access ? 'disabled' : false
    },
    on: {
      "click": _vm.createForm
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/extdisk_create')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "w5-snapshot-table margin-top-5"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "w5-tab-table-th-0"
  }, [(_vm.cacheData) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")('service/extdisk')))]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "w5-tab-table-th-1"
  }, [(_vm.cacheData) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")('service/extdisk_attached')))]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "w5-tab-table-th-2"
  }, [(_vm.cacheData) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")('main/status')))]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "w5-tab-table-th-3"
  }, [(_vm.cacheData) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")('main/created')))]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "w5-column-opers",
    staticStyle: {
      "width": "45px"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', [(_vm.cacheData && _vm.cacheData.length) ? _vm._l((_vm.cacheData), function(row) {
    return _c('tr', {
      key: row['service_id']
    }, [_c('td', {
      attrs: {
        "aria-label": _vm._f("ftc")('service/extdisk')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell",
      class: {
        'w5-link': _vm.Access && !row['Status']['loader'] && !row['Status']['timer']
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.updateForm(row['service_id'], row)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(row['service_name_full'])) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', {
      attrs: {
        "aria-label": _vm._f("ftc")('service/extdisk_attached')
      }
    }, [_c('div', {
      staticClass: "w5-list-iso"
    }, [(row['service_data'] && row['service_data']['extdisk'] && row['service_data']['extdisk']['attached'] === true) ? [(!row['service_status_text']) ? _c('button', {
      staticClass: "btn btn-default w5-eject-iso-button",
      attrs: {
        "title": _vm._f("ftc")('main/detach')
      },
      on: {
        "click": function($event) {
          return _vm.ejectOuterDisk(row, $event)
        }
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "eject"
      }
    })], 1) : _vm._e(), _vm._v(" "), (String(row['parent_id']) !== _vm.vdsId) ? _c('div', {
      staticClass: "hidden-ellipsis",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_c('linkComponent', {
      attrs: {
        "url": '/vds/view/' + row['parent_id'],
        "text": row['parent_name']
      }
    })], 1) : _c('div', {
      staticClass: "hidden-ellipsis",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [(row['service_data']['extdisk']['device']) ? _c('span', [_vm._v(_vm._s(row['service_data']['extdisk']['device']))]) : _c('span', [_vm._v(_vm._s(row['parent_name']))])])] : _c('span', [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")('main/no'))))])], 2)]), _vm._v(" "), _c('td', {
      attrs: {
        "aria-label": _vm._f("ftc")('main/status')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [(row['Status']['loader']) ? _c('span', {
      staticClass: "margin-right-10",
      class: 'w5-status-color-' + row['service_status'],
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(_vm._s(_vm._f("lower")(row['Status']['status'])) + " "), _c('img', {
      staticStyle: {
        "margin-left": "6px"
      },
      attrs: {
        "src": require("../../assets/img/loading-hor16.gif")
      }
    })]) : (row['Status']['timer']) ? _c('span', {
      staticClass: "margin-right-10",
      class: 'w5-status-color-' + row['service_status'],
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(_vm._s(_vm._f("lower")(row['Status']['status'])) + " "), _c('font-awesome-icon', {
      staticStyle: {
        "margin-left": "6px"
      },
      attrs: {
        "icon": "clock"
      }
    })], 1) : _c('span', {
      staticClass: "margin-right-10",
      class: 'w5-status-color-' + row['service_status'],
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(_vm._s(_vm._f("lower")(row['Status']['status'])))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "aria-label": _vm._f("ftc")('main/created')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.formater_StrDateFormat(row['service_created'], 'd.m.Y')) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', [(_vm.$store.state.windowWidth <= 767) ? _c('div', {
      staticClass: "w5-opers-button-for-mobile"
    }, [(_vm.Access && !row['Status']['loader'] && !row['Status']['timer']) ? _c('div', {
      staticClass: "w5-opers-button-curd-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteAction(row['service_id'], row)
        }
      }
    }, [_c('font-awesome-icon', {
      staticClass: "color-red",
      staticStyle: {
        "font-size": "16px"
      },
      attrs: {
        "icon": "trash-alt"
      }
    })], 1) : _vm._e()]) : (_vm.$store.state.windowWidth > 767 && _vm.thereAreItems(row)) ? _c('div', {
      staticClass: "btn-group w5-opers-button",
      class: {
        'w5-opers-button-opened': row['__btnShow']
      },
      attrs: {
        "data-id": row['id']
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleMenu(row)
        }
      }
    }, [_c('span', {
      staticClass: "dropdown-toggle"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "bars"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "caret"
    })], 1), _vm._v(" "), _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row['__btnShow']),
        expression: "row['__btnShow']"
      }],
      staticClass: "dropdown-menu",
      style: (_vm.cssUl),
      attrs: {
        "role": "menu"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.Access && !row['Status']['loader'] && !row['Status']['timer'] && _vm.canConnectDisk(row)) ? _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.insertDisk(row)
        }
      }
    }, [_c('font-awesome-layers', {
      staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "hdd"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("capitalize")(_vm._f("ftc")('main/attach main/disk'))) + "\n\t\t\t\t\t\t\t\t\t")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.Access && !row['Status']['loader'] && !row['Status']['timer'] && !_vm.canConnectDisk(row)) ? _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.ejectOuterDisk(row, $event)
        }
      }
    }, [_c('font-awesome-layers', {
      staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "eject"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("capitalize")(_vm._f("ftc")('main/detach main/disk'))) + "\n\t\t\t\t\t\t\t\t\t")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.Access && !row['Status']['loader'] && !row['Status']['timer']) ? _c('li', {
      staticClass: "divider"
    }) : _vm._e(), _vm._v(" "), (_vm.Access && !row['Status']['loader'] && !row['Status']['timer']) ? _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteAction(row['service_id'], row)
        }
      }
    }, [_c('span', {
      staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
    }, [_c('font-awesome-icon', {
      staticClass: "color-red",
      attrs: {
        "icon": "trash-alt"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/delete')) + "\n\t\t\t\t\t\t\t\t\t")], 1)]) : _vm._e()])]) : _vm._e()])])
  }) : _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": require("../../assets/img/puzzle.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-size-110 w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])])])], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFormModal),
      expression: "showFormModal"
    }],
    staticClass: "modal-mask",
    on: {
      "mousedown": function($event) {
        _vm.maskModalFlag = true
      },
      "mouseup": function () { return this$1.hideFormModal(false); }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-form",
    attrs: {
      "id": "modal-form"
    },
    on: {
      "mousedown": _vm.onModalMouse,
      "mouseup": _vm.onModalMouse
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.formModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideFormModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.formMode === 'updateConfirm') ? [_c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.formConfirmText)),
      expression: "localeFtc(formConfirmText)"
    }],
    staticClass: "padding-0-5"
  })])] : [(_vm.form && _vm.form.fields) ? _c('div', {
    staticClass: "modal-body"
  }, [(_vm.showAdditionalInfo) ? _c('div', {
    staticClass: "w5-form-additional-info"
  }, [(_vm.formInfo.max) ? _c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/available_to_order')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.formInfo.max))]), (_vm.formInfo.for) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.formInfo.for)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.formInfo.cost) ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("ftc")('servicetype/cost')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.formInfo.cost))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/ruble')),
      expression: "localeFtc('main/ruble')"
    }]
  }), (_vm.formInfo.period) ? _c('span', [_vm._v(" / " + _vm._s(_vm._f("ftc")(_vm.formInfo.period)))]) : _vm._e(), (_vm.formInfo.for) ? _c('span', [_vm._v(" / 1 " + _vm._s(_vm._f("ftc")(_vm.formInfo.for)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.form_Loading
    }
  }, _vm._l((_vm.form.fields), function(row, index) {
    return _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleField(row)
      }
    }, [(row) ? _vm._l((row), function(field) {
      return _c('Field', {
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "fieldInModal": true,
          "action": _vm.formMode,
          "Field": field,
          "listBlockToOut": 1,
          "diskTypeValue": field._field_name === 'quantity' ? _vm.diskType : null,
          "crud": "disks"
        },
        on: {
          "dragStart": _vm.onDragStart,
          "dragEnd": _vm.onDragEnd,
          "outerDiskTypeChanged": _vm.onDiskTypeChanged,
          "valueChanged": function($event) {
            return _vm.fieldChanged(field)
          }
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }) : _vm._e()], 2)
  }), 0)])]) : _vm._e()], _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    attrs: {
      "disabled": _vm.form_Loading
    },
    on: {
      "click": _vm.formModalBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.formMode === 'create' ? 'main/create' : _vm.formMode === 'update' ? 'main/save' : 'main/continue')))])])], 2)])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/extdisk')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.deleteModalText)),
      expression: "localeFtc(deleteModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.deleteModalTimer && _vm.deleteModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteBackupBegin
    }
  }, [_vm._v(_vm._s(_vm.modalDeleteButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.modalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.modalText)),
      expression: "localeFtc(modalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    class: {
      'btn-submit-danger': _vm.modalButtonTitle.indexOf(_vm.localeFtc('main/detach')) > -1
    },
    attrs: {
      "disabled": _vm.modalTimer && _vm.modalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.diskProcessBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.modalButtonTitle)))])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66c13a50"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vds/disk.vue
// module id = 588
// module chunks = 0